const OLD_R2_ORIGIN = 'https://pub-b28d149e3b474dff8cbd549a5342d6ed.r2.dev';
const NEW_CDN_ORIGIN = 'https://cdn.tradermap.io';

/**
 * Rewrite old R2 URLs to new CDN domain.
 * URLs already on the new domain or non-R2 URLs pass through unchanged.
 */
export function rewriteR2Url(url) {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith(OLD_R2_ORIGIN)) {
    return NEW_CDN_ORIGIN + url.slice(OLD_R2_ORIGIN.length);
  }
  return url;
}
